import { hasTelegramWebApp, signalTelegramReady } from "./webApp";

/**
 * Triggers the official Telegram readiness signal once the app's own UI has
 * actually painted. Call this from the first real screen's mount effect
 * (see WelcomeScreen), after at least one animation frame — never before.
 *
 * telegram-web-app.js loads asynchronously, so `window.Telegram.WebApp` may
 * not exist yet at this point: if so, this polls lightly for a bounded
 * window rather than giving up immediately. Polling never blocks or hides
 * the UI — the screen stays visible and usable throughout, on Telegram or
 * in a plain browser, whether or not the bridge ever shows up.
 */
export function triggerTelegramReadyAfterPaint(): void {
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      attemptReady(0);
    });
  });
}

const POLL_MS = 150;
const MAX_ATTEMPTS = 67; // ~10s

function attemptReady(attempt: number): void {
  if (hasTelegramWebApp()) {
    fireReady();
    return;
  }
  if (attempt >= MAX_ATTEMPTS) return; // Bridge never showed up — browser/fallback UI remains visible and usable.
  setTimeout(() => attemptReady(attempt + 1), POLL_MS);
}

function fireReady(): void {
  signalTelegramReady();
}
